<div class="container" #container>

	<div class="overlay" (click)="onCloseClick()"></div>

	<!-- <div class="wrapper" style="background-image: url(assets/img/updates/bg.jpg)"> -->
	<div class="wrapper" style="background-image: url(assets/img/moviesphere-plus/moviesphere-plus-background-film-tv-shows-grid-desktop.jpg)">

		<div class="content" #content>


			<!-- <img src="assets/img/icons/email.png" class="icon"> -->
		
			<div class="form" #form>
				<div class="label">Get Email Updates for</div>
				<div class="sublabel">
                    <img src="assets/img/moviesphere-plus/moviesphere-plus-logo-gradient-desktop.png" alt="">
                </div>
				<!-- <div class="sublabel2"></div> -->

				<div class="inputWrapper">
					<input type="text" class="email" [placeholder]="placeholder" #emailAddress [(ngModel)]="email" >
					<input type="submit" class="submit" value="Submit" (click)="onSubmitClick()">
				</div>

				<div class="messages" #messageElement>{{ message }}</div>

				<div class="legal">
					By submitting, I'm agreeing to receive email updates about <b>MovieSphere+</b> and other Lionsgate properties. I certify that I am at least 13 years old, and under this site's privacy policy.
				</div>

			</div>
			
		</div>

		<div class="success" #successElement>
			<img src="assets/img/icons/email.png" class="icon">
			<div class="label">Your email has been added</div>			
		</div>

		<div class="closeButton" (click)="onCloseClick()" (mouseenter)="onCloseOver()" (mouseleave)="onCloseOut()" #btnClose>
			<div class="closeLine"></div>
			<img src="assets/img/moviesphere-plus/close-button-v2.png" alt="" class="closeImg">
			<img src="assets/img/moviesphere-plus/close-button-rollover-v2.png" alt="" class="closeImgOver">
		</div>
	</div>
</div>		
